// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29vp4","badges":"styles_badges__gk7dH"};